import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Brand } from '@/components/Brand';
import { Flaming7 } from '@/components/Flaming7';
import { CasinoButton } from '@/components/CasinoButton';
import { useMeBootstrap } from '@/hooks/useMeBootstrap';
import { useSession } from '@/state/session';
import { tournamentApi } from '@/api/tournament';

export function Home() {
  useMeBootstrap();
  const user = useSession((s) => s.user);

  // Read the active tournament so the CTA can name it. Open endpoint — works
  // for anonymous visitors too (returns tournament=null if none active).
  const activeQ = useQuery({
    queryKey: ['tournament', 'active'],
    queryFn: tournamentApi.active,
    staleTime: 30_000,
  });
  const activeName = activeQ.data?.tournament?.name ?? null;

  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-8 px-5 py-10 text-center">
      <Flaming7 size={200} />
      <Brand size="lg" />
      <p className="max-w-xs text-cabinet-cream/70">
        Private tournament tracker for our home slot machine.
      </p>

      <div className="flex flex-col items-center gap-3">
        {user ? (
          <>
            <Link to="/tournament/active" className="block">
              <CasinoButton variant="red">Active tournament</CasinoButton>
              {activeName && (
                <p className="mt-2 text-xs uppercase tracking-widest text-cabinet-gold-bright">
                  {activeName}
                </p>
              )}
            </Link>
            <Link to="/me">
              <CasinoButton variant="ghost">My account</CasinoButton>
            </Link>
          </>
        ) : (
          <Link to="/login">
            <CasinoButton variant="gold">Sign in</CasinoButton>
          </Link>
        )}
      </div>
    </main>
  );
}
